import { render, staticRenderFns } from "./DocumentApproval.vue?vue&type=template&id=5cce23cd&scoped=true"
import script from "./DocumentApproval.vue?vue&type=script&lang=js"
export * from "./DocumentApproval.vue?vue&type=script&lang=js"
import style0 from "./DocumentApproval.vue?vue&type=style&index=0&id=5cce23cd&prod&scoped=true&lang=css"
import style1 from "./DocumentApproval.vue?vue&type=style&index=1&id=5cce23cd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cce23cd",
  null
  
)

export default component.exports